/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_SubmitInputs */

const cs_auth_signup_submit = /** @type {(inputs: Auth_Signup_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Založit účet`)
};

const en_auth_signup_submit = /** @type {(inputs: Auth_Signup_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create account`)
};

/**
* | output |
* | --- |
* | "Create account" |
*
* @param {Auth_Signup_SubmitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_submit = /** @type {((inputs?: Auth_Signup_SubmitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_SubmitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_submit(inputs)
	return cs_auth_signup_submit(inputs)
});